import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosFerreiraPassagens = {
    ...dadosAgenciaComum,
    id: 'ferreirapassagens',
    nome: 'Ferreira Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-P25JP5N']
};
